import { Button, Dialog, Typography } from '@cobliteam/ui/components';
import reportXLSIcon from './report-xls.svg';

interface SuccessExportReportModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  emails: string[];
}

const SuccessExportReportModal = ({ open, setOpen, emails }: SuccessExportReportModalProps) => (
  <Dialog open={open} onOpenChange={setOpen}>
    <Dialog.Content modalSize='sm'>
      <Dialog.Title className='sr-only' />
      <Dialog.Description className='sr-only' />
      <Dialog.Body className='flex flex-col items-center gap-5'>
        <Dialog.Close className='self-end' />
        <img src={reportXLSIcon} alt='Report XLS' />
        <Typography variant='input-placeholder' className='text-center'>
          Dependendo do período selecionado, seu relatório pode demorar até 15 minutos para chegar na sua caixa de entrada.
        </Typography>
        <Typography variant='heading-2'>O relatório será enviado para os e-mails:</Typography>
        <div>
          {emails.map((email) => (
            <Typography key={email} className='text-center'>
              {email}
            </Typography>
          ))}
        </div>
        <Dialog.Close asChild>
          <Button variant='ghost'>Entendi</Button>
        </Dialog.Close>
      </Dialog.Body>
    </Dialog.Content>
  </Dialog>
);

export default SuccessExportReportModal;
